import apiService, { HOST,showPdfNewTab } from "./BaseApi";
import Utils from '@/scripts/Utils';
import store from '@/store/index'
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"

const ENDPOINT_PROPOSAL_PATH = "waterscan/proposal";
const ENDPOINT_DIAGNOSTIC_PROPOSAL_PATH = "/waterscan/diagnostic/proposal";
const ENDPOINT_DIAGNOSTIC_CHECKLIST_PATH = "/waterscan/diagnostic/checklist";
const ENDPOINT_SIMPLIFIED_PROPOSAL_PATH = "waterscan/simplified-proposal";
const ENDPOINT_SIMPLIFIED_PROPOSAL_PATH_V2 = "waterscan/v2/simplified-proposal";
const ENDPOINT_CHECKLIST_PATH = "waterscan/checklist";
const ENDPOINT_CHECKLIST_WITH_PHOTO_PATH = "waterscan/checklist-with-photo";
const ENDPOINT_CHECKLIST_WITH_PHOTO_SEVEN_STEPS_PATH = "waterscan/diagnostic/checklist-with-photo";


const WaterScanApi = {
    generateProposalPdf: async (proposalId) => await apiService.post(ENDPOINT_PROPOSAL_PATH, { proposalId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),
    generateChecklistPdf: async (proposalId) => await apiService.post(ENDPOINT_CHECKLIST_PATH, { proposalId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),
    generateChecklisWithPhototPdf: async (proposalId) => await apiService.post(ENDPOINT_CHECKLIST_WITH_PHOTO_PATH, { proposalId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),
    generateChecklisWithPhotoSevenStepsPdf: async (proposalId, leadId) => await apiService.post(ENDPOINT_CHECKLIST_WITH_PHOTO_SEVEN_STEPS_PATH, { proposalId, leadId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),
    generateSimplifiedProposalPdf: async (proposalId) => await apiService.post(ENDPOINT_SIMPLIFIED_PROPOSAL_PATH, { proposalId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),
    generateSimplifiedProposalPdfV2: async (proposalId) => await apiService.post(ENDPOINT_SIMPLIFIED_PROPOSAL_PATH_V2, { proposalId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),
    
    generateDiagnosticProposalPdf: async (proposalId) => await apiService.post(ENDPOINT_DIAGNOSTIC_PROPOSAL_PATH, { proposalId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),
    generateDiagnosticChecklistPdf: async (proposalId) => await apiService.post(ENDPOINT_DIAGNOSTIC_CHECKLIST_PATH, { proposalId, currentUserId: store.state.currentUser?.uid, env: Utils.getEnv() }),

    downloadPdf: async (response) => {
        if (response.status === 200 && response.data.signedUrl) showPdfNewTab(response.data.signedUrl)
        else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
    },
};

export default WaterScanApi;